import React, { useState, useEffect } from "react";
import ProceedModalPrint from "../../Component/ProceedModalPrint";
import { useSelector } from "react-redux";
import Layout from "../../reusables/layout/layout";
import Requisition from "../../Component/requisitionforms/requisition_bece_cas";

const Junior = () => {

    const user = useSelector((state) => state.user.data.details);
    const token = useSelector((state) => state?.user?.data?.token);


    return (
        <>
            
                {token && <Requisition examName={"CAS/Placement"} examType='CAS/Placement Examination' />

                }
          

        </>
    )
};

export default Junior;